"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("config");
const EnvironmentHelper_1 = require("../../helpers/EnvironmentHelper");
const LoggerHelper_1 = require("../../helpers/LoggerHelper");
const SharedTypes_1 = require("../../models/SharedTypes");
const ALauncher_1 = require("../common/ALauncher");
class Launcher extends ALauncher_1.ALauncher {
    _getLauncherUrl() {
        if (EnvironmentHelper_1.os === EnvironmentHelper_1.OperatingSystems.Android) {
            return config_1.default.urls.doLauncher.intentUri(SharedTypes_1.Actions.Chat, this.props.profile.skypeId, LoggerHelper_1.logger.getSessionId(), 'launcher', config_1.default.urls.app.download);
        }
        return config_1.default.urls.doLauncher.skypeUri(SharedTypes_1.Actions.Chat, this.props.profile.skypeId, LoggerHelper_1.logger.getSessionId(), 'launcher');
    }
    _getLoggerAction() {
        return 'join-profile';
    }
}
exports.Launcher = Launcher;
